import { FlexLayout, Text } from '@deity/falcon-ui';
import { Icon } from '@deity-io/portal-ui';
import { CACHE_ONLY, ENTITY_PATH, ENTITY_PATH_ID } from 'contracts/constants';
import type { FC } from 'react';
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useGetFlowsByPackageVersionLazyQuery } from 'services/graphql/generated/hooks';
import { ContentStatus } from 'services/graphql/generated/schemas';
import { getParams } from 'utils';

const FlowsBadge: FC = () => {
  const { pathname } = useLocation();
  const { packageId, versionUuid } = getParams(pathname, [ENTITY_PATH_ID, ENTITY_PATH]) as any;
  const [getAllFlows, { data: flows }] = useGetFlowsByPackageVersionLazyQuery(CACHE_ONLY);

  useEffect(() => {
    if (versionUuid) {
      getAllFlows({
        variables: {
          packageVersionUuid: versionUuid,
          offset: 0,
          limit: 99
        }
      });
    }
  }, [versionUuid]);

  const activeFlows =
    flows?.getFlowsByPackageVersion?.data?.filter(flow => flow.status !== ContentStatus.New)?.length || 0;

  return (
    <Link to={`/packages/${packageId}/${versionUuid}/flows`} style={{ textDecoration: 'none' }}>
      <FlexLayout mr="xs" bg="badgeBg" alignItems="center" css={{ borderRadius: '4px', padding: '2px 10px' }}>
        <Text color="secondary" mr="xs" style={{ textTransform: 'uppercase' }}>
          Flows
        </Text>
        <FlexLayout alignItems="center" color="white">
          <Icon icon="notStarted" sx={{ fontSize: '20px', opacity: 0.7 }} />
        </FlexLayout>
        <Text ml="xs" color="secondary" style={{ textTransform: 'uppercase' }} fontWeight="bold">
          {activeFlows} active
        </Text>
      </FlexLayout>
    </Link>
  );
};

export default FlowsBadge;
